export const events = {
  eventsCardDurationText: 'тривалість',
  eventsSearchInputText: 'Пошук',
  eventsRegisteredToEventAlertTitle: 'Зареєстровано!',
  eventsUnregisteredToEventAlertTitle: 'Реєстрацію відмінено!',
  eventsExternalRegistrationPopupTitle: 'Реєстрація',
  eventsExternalRegistrationPopupContent: 'Вдалось зареєструватися за зовнішнім посиланням?',
  eventsExternalRegistrationNoButtonTitle: 'Ні',
  eventsExternalRegistrationYesButtonTitle: 'Так',
  eventsCurtainCopyOptionTitle: 'Скопіювати посилання',
  eventsCurtainFlagOptionTitle: 'Поскаржитись',
  eventsLinkCopiedAlertText: 'Посилання скопійовано!',
  eventsCurtainAddToCalendOptionTitle: 'Додати в календар',
  eventdetailsAgendaButtonTitle: 'Розклад',
  eventdetailsOnMapButtonTitle: 'На мапі',
  eventdetailsOnlineLocationTitle: 'Онлайн',
  eventdetailAmountsRegisteredText: 'учасників',
  eventdetailsSeeAllButtonTitle: 'Усі',
  eventdetailsRegisteredButtonTitle: 'Зареєстрован(а)',
  eventdetailsRegisterButtonTitle: 'Зареєструватися',
  eventdetailsRegisteredAlertText: 'Зареєстровано!',
  eventdetailsUnregisteredAlertText: 'Реєстрацію відмінено!',
  eventdetailsAgendaTitle: 'Розклад',
  eventdetailsSeeAllRegisteredCurtainTitle: 'Зареєстровані',
  eventdetailsSpeakersCurtainTitle: 'Спікери',
  eventdetailsSpeakersSectionTitle: 'Спікери',
  eventdetailsSpeakersSectionSeeAllButtonTitle: 'Усі',
  eventdetailsCustomSectionSeeAllButtonTitle: 'Усі',
  eventdetailsCurtainCopyOptionTitle: 'Скопіювати посилання',
  eventdetailsCurtainFlagOptionTitle: 'Поскаржитись',
  eventsdetailsLinkCopiedAlertText: 'Посилання скопійовано!',
  eventdetailsCurtainAddToCalOptionTitle: 'Додати в календар',
  eventDetailsAddCalendarPopupTitle: 'Календар',
  eventdetailsAddCalendarPopupContent: 'Додати в календар?',
  eventdetailsAddCalendarPopupNoButtonTitle: 'Ні',
  eventdetailsAddCalendarPopupYesButtonTitle: 'Так',
  eventdetailsSpeakerCurtainCopyOptionTitle: 'Скопіювати посилання',
  eventdetailsSpeakerCurtainFlagOptionTitle: 'Поскаржитись',
  eventsdetailsSpeakersLinkCopiedAlertText: 'Посилання скопійовано!',
  eventdetailsCustomSectionCurtainCopyOptionTitle: 'Скопіювати посилання',
  eventdetailsCustomSectionCurtainFlagOptionTitle: 'Поскаржитись',
  eventsFlag: 'Поскаржитись',
  eventsJoin: 'Перейти',
  eventdetailsCustomSectionLinkCopiedAlertText: 'Посилання скопійовано!',
  eventContentReported: 'Скаргу надіслано',
  eventsError: 'Щось пішло не так!',
  eventdetailsExternalRegistrationPopupContent: 'Вдалось зареєструватися за зовнішнім посиланням?',
  eventdetailsExternalRegistrationNoButtonTitle: 'Ні',
  eventdetailsExternalRegistrationYesButtonTitle: 'Так',
  eventdetailsExternalRegistrationPopupTitle: 'Реєстрація',
  eventsCardRegisteredButtonTitle: 'Зареєстрован(а)',
  eventsCardRegisterButtonTitle: 'Зареєструватися',
  eventsJoinLink: 'Посилання на приєднання до події: [url]{link}[/url][br]',
  eventsGuest: 'Гість',
  eventsNoSessionInDay: 'Немає подій у вказаному дні.',
  eventsShowUpcomingEvent: 'Показати найближчу подію'
}
